export var SIZES_MAP = {
  small: 20,
  medium: 30,
  large: 50,
  xlarge: 100
};
export var DEFAULT_SIZE = SIZES_MAP.small;


//////////////////
// WEBPACK FOOTER
// /Users/leedongwei/Documents/Projects/crimp-application/node_modules/@atlaskit/spinner/dist/esm/Spinner/constants.js
// module id = 347
// module chunks = 0